import React from 'react';
import image from '../../Images/LOGO_BLACK.png';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSpring, animated } from 'react-spring';

export default function Loading() {
  return (
    <div
      style={{
        position: 'fixed', // Cover the entire viewport
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#fff', // Solid background to block underlying content
        zIndex: 9999, // Ensure it stays on top of all other elements
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        pointerEvents: 'none', // Prevent interaction with underlying elements
      }}
    >
      <AnimatedImage />
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      <span style={{ marginTop: '10px', color: '#666' }}>Cargando...</span>
    </div>
  );
}

const AnimatedImage = () => {
  const props = useSpring({
    from: { opacity: 0, transform: 'scale(0.8)' }, // Start with a slight zoom-out
    to: { opacity: 1, transform: 'scale(1)' }, // Fade in and zoom to normal size
    config: { duration: 1000 }, // Smooth animation duration
  });

  return (
    <animated.img
      src={image}
      alt="logo"
      style={{
        width: '100px',
        marginBottom: '20px',
        ...props,
      }}
    />
  );
};
